/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ activation: NonNullable<unknown> }} ActivationInputs */



/**
* | activation | output |
* | --- | --- |
* | "false" | "Disabled" |
* | "true" | "Enabled" |
* | * | "Disabled" |
*
* @param {ActivationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const activation = /** @type {((inputs: ActivationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActivationInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.activation === "false") return /** @type {LocalizedString} */ (`Disabled`);
		if (i?.activation === "true") return /** @type {LocalizedString} */ (`Enabled`);
		return /** @type {LocalizedString} */ (`Disabled`)
	}
	{
		if (i?.activation === "false") return /** @type {LocalizedString} */ (`Désactivé`);
		if (i?.activation === "true") return /** @type {LocalizedString} */ (`Activé`);
		return /** @type {LocalizedString} */ (`Désactivé`)
	}
});